import { PluginService } from '../../plugins/services/plugin.service';

export class PluginProxy {

    protected prefix: string;

    public constructor(protected pluginService: PluginService, entityName: string) {
        this.prefix = 'quick-addit-' + entityName + '-entity';
    }

    public add(slotName: string, name: string, component: any, editOrCreate = 'both', order: number = 0) {

        let slotSuffixes = ['create', 'edit'];

        if (editOrCreate !== 'both') {
            slotSuffixes = [editOrCreate];
        }

        slotSuffixes.forEach(slotSuffix => {
            this.pluginService.add(this.getSlotName(slotName, slotSuffix), name, component, order);
        });
    }

    public remove(slotName: string, name: string, editOrCreateSlot = 'both') {

        let slotSuffixes = ['create', 'edit'];

        if (editOrCreateSlot !== 'both') {
            slotSuffixes = [editOrCreateSlot];
        }

        slotSuffixes.forEach(slotSuffix => {
            this.pluginService.remove(this.getSlotName(slotName, slotSuffix), name);
        });

    }

    protected getSlotName(shortSlotName, suffix) {
        return this.prefix + '-' + shortSlotName + '-' + suffix;
    }

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/quick-addit/classes/plugin-proxy.class.ts